import {
  FETCH_TEST_PAGES,
  SUBMIT_TEST_RESULT,
  FETCH_TEST_HISTORY,
  LOADING_TEST,
  CLEAN_AUTH
} from "../actions/type";

const INIT_STATE = {
  currentTestPages: [],
  currentTestLevel: null,
  testHistory: [],
  testHistoryTotal: 0,
  isLoadingTest: false
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_TEST_PAGES:
      return {
        ...state,
        currentTestPages: payload.pages,
        currentTestLevel: payload.bookLevel,
        isLoadingTest: false
      };

    case SUBMIT_TEST_RESULT:
      return {
        ...state,
        testHistory: [payload.testResult, ...state.testHistory]
      };

    case FETCH_TEST_HISTORY:
      return {
        ...state,
        testHistory: payload.testResults,
        testHistoryTotal: payload.total,
        isLoadingTest: false
      };

    case LOADING_TEST:
      return {
        ...state,
        isLoadingTest: payload
      };

    case CLEAN_AUTH:
      return { ...INIT_STATE };

    default:
      return state;
  }
};
